import { connect } from "react-redux";

import ConverterManager from "../Components/Converters/ConverterManager";
import {
  addConverter,
  removeConverter,
  updateConverterType,
  setConfigParam,
  setConvertersManagerOpen,
  setConverterConfigOpen,
  setConverterOnEdition,
} from "../store/actions/actions";

const mapStateToProps = (state) => {
  return {
    converters: state.converters,
    locale: state.locale,
    isConvertersManagerOpen: state.isConvertersManagerOpen,
    isConverterConfigOpen: state.isConverterConfigOpen,
    converterOnEdition: state.converterOnEdition,
  };
};

const mapDispatchToProps = {
  addConverter,
  removeConverter,
  updateConverterType,
  setConfigParam,
  setConvertersManagerOpen,
  setConverterConfigOpen,
  setConverterOnEdition,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConverterManager);
